import React, { useState, useEffect, useContext} from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import { addDays } from 'date-fns';

//---------COMPONENTES----------------------
import ModalEvento from '../../componentes/Modal/ModalEvento';
import ModalVeiculo from '../../componentes/Modal/ModalVeiculo';

import { ListaEventos } from '../../componentes/ListarPesquisas/ListaEvento';
import { DetalheEvento } from '../../componentes/Detalhes/detalheEvento';
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';

import LoadingContent from '../../componentes/loading/loading';
import { Functions, FunctModal } from '../../componentes/Functions';
import { Paginacao } from '../../componentes/Paginacao';
import { AlertComp } from '../../componentes/alerte/index';

import { AddOrcamento } from '../../componentes/Cadastro/addOrcamento';
import { CondutorEvento } from '../../componentes/Cadastro/CondutorEvento';

//---------SERVICES--------------------------
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
// ------------------------------------------
const GRUPOS_EVENTO = [
    { key: 'assistencia', label: 'Assistencia 24h' },
    { key: 'perifericos', label: 'Perifericos', tipos: ['Reparos_part', 'Retrovisor_part', 'Lanterna_part', 'Vidro_part'] },
    { key: 'carroReserva', label: 'Carro reserva', tipos: ['C.Reserva'] },
    { key: 'colisao', label: 'Colisao', tipos: ['Colisao_part', 'Terceiro'] },
    { key: 'rouboPT', label: 'Roubo/PT/Financ.', tipos: ['Roubo', 'Colisao_PT', 'Colisao_Incendio'] },
        { key: 'vistoria', label: 'Vistoria', tipos: ['vistoria_evento'] },
    ];

// Tipos fora dos demais grupos pertencem a Assistencia 24h
const grupoDoEvento = (tipo) => {
    const g = GRUPOS_EVENTO.find(gr => gr.tipos && gr.tipos.includes(tipo));
    return g ? g.key : 'assistencia';
};

export function EVENTOS(props) {
    const { state, dispatch } = useContext(Context);
    const { cliente, logado } = state.cliente;
    const { veiculo } = state.veiculo;
    const { evento } = state.evento;

    const { parametroInit, displayModal, playmodal, listaPesquisa, playLista } = state.parametros;
    const { pesquisaIdVeiculo, loading } = parametroInit;

    const { id_Evento, codEvenBD } = evento;
    const { listaEvento } = listaPesquisa;

    const [Statusconcluido, setCCConcluido] = useState('');
    const [somaValorPago, setSomaValorPago] = useState('')
    const [newValor_produtos, editValorProdutos] = useState('');
    const [newValor_servico, editValorServicos] = useState('');
    const [TotalEven, setTotalEven] = useState('');

    const [newStatus, setNewStatus] = useState('');
    const [refDelete, setRefDelet] = useState('');

    const { Play_Modal_Add} = Functions();
    const { FecharModal } = FunctModal();

    const { pesqIDveiculo } = Api_Veiculos();
    const { pesqidcliente } = Api_Clientes();
    const { PesqEventoCod, PesqIdEvento, PesquisarEvento, BuscaTodosEventos, PesqPorData, PesquisaUserCad } = ApiEvento();

    const dataAtual = new Date();

    //-----------------------------------------------
    useEffect(() => {
        if (pesquisaIdVeiculo) {
            pesqIDveiculo();
        }
    }, [pesquisaIdVeiculo]);

    //-Atualizar Evento - Colocar como Pago "Statusconcluido" ou Aberto---------
    async function AtualizarConcluido() {
        if (somaValorPago >= TotalEven && Statusconcluido === false) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: true,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Pago!');
                }
            })
        };
        //--------
        if (somaValorPago < TotalEven && Statusconcluido === true) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: false,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Esta em Abeto!');
                }
            })
        };
    };

    //--------------------------------------------------
    function FecharAlerte() {
        props.setAletDelete(false)
    };
    //-- Remover evento deletado da lista atual, preservando os filtros já aplicados -----
    function RemoverEventoDaLista(idEvento) {
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaEvento: listaPesquisa.listaEvento.filter(ev => ev._id !== idEvento),
            }
        });
    };

    //-----------------------------------------------
    async function ExcluirEste() {
        if (refDelete === "delete") {
            await api.delete(`evento/delete/${evento.id_Evento}`)
            .then(() => {
                alert('Deletado Definitivo')
                RemoverEventoDaLista(evento.id_Evento);
                props.setAletDelete(false);
            })
            .catch(() => alert('erroooo!!!'));
        }
        else {
            await api.put(`evento/atualizarSimples/${evento.id_Evento}`, {
                status: 'E',
                logs: {
                    idUsuario: logado.id_Cliente,
                    acao: 'excluir evento',
                    plataforma: "interno",
                    localizacao: {
                        latitude: veiculo.latitude ? veiculo.latitude : null,
                        longitude: veiculo.longitude ? veiculo.longitude : null,
                    }
                }
            })
            .then(() => {
                RemoverEventoDaLista(evento.id_Evento);
                props.setAletDelete(false);
            });
        }
    };

    //------------------------------------
    useEffect(() => {
        AtualizarConcluido()
    }, [somaValorPago && TotalEven && Statusconcluido])

    // ------------------------------
    useEffect(() => {
        pesqidcliente();
    }, [cliente.id_Cliente]);


    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca])

    //------------Somar o Total-----------------
    const [Total, setTotal] = useState(0);
    let tt = parseFloat(newValor_servico) + parseFloat(newValor_produtos);

    useEffect(() => {
        if (tt) {
            setTotal(tt)
        }
    }, [tt])

    //-------------------Gerar Codigos-----------
    useEffect(() => {
        let inic = (1);
        let codinic = veiculo.placa + '-0' + inic;
        const regex = new RegExp(codinic, 'i'); // Expresao regular
        let verific = regex.test(codEvenBD) // verificar se ja existe este codigo no banco de dados
        //--------
        if (verific) { // se cod for igual, gerar novo
            for (; verific; inic++) {
                let codNovo = veiculo.placa + '-0' + inic
                const regex = new RegExp(codNovo, 'i');
                let verific = regex.test(codEvenBD)

                if (!verific) {
                    dispatch({
                        type: 'set_Evento',
                        payload: { ...evento, codEvento: codNovo }
                    });
                    break
                }
            };
        } else {
            if (veiculo.placa) {
                dispatch({
                    type: 'set_Evento',
                    payload: { ...evento, codEvento: codinic }
                });
            }
        }
    }, [codEvenBD && veiculo.placa]);

    //---------------------------------------------------
    const [abertoEvento, setabertoEvento] = useState([]);
    const [pendenteEvento, setpendenteEvento] = useState([]);
    const [Concluidovento, setConcluidovento] = useState([]);

    const [Aberto_For, setAberto_For] = useState([]);
    const [Pendente_For, setPendente_For] = useState([]);
    const [Concluido_For, setConcluido_For] = useState([]);

    //Paginação------------------
    const [itemsPage, setitemsPage] = useState(20);

    // ---Abenta
    const [paginaAtualA, setPaginaAtual_A] = useState(0);
    const startIndexA = paginaAtualA * itemsPage;
    const endIndexA = startIndexA + itemsPage;
    // ---Pendente
    const [paginaAtualP, setPaginaAtual_P] = useState(0);
    const startIndexP = paginaAtualP * itemsPage;
    const endIndexP = startIndexP + itemsPage;
    // ---Concluido
    const [paginaAtualC, setPaginaAtual_C] = useState(0);
    const startIndexC = paginaAtualC * itemsPage;
    const endIndexC = startIndexC + itemsPage;

    useEffect(() => {
        setPaginaAtual_A(0);
        setPaginaAtual_P(0);
        setPaginaAtual_C(0);

    }, [listaEvento])

    const [gruposSel, setGruposSel] = useState([]);
    const toggleGrupo = (key) => {
        setGruposSel(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
        setPaginaAtual_A(0);
        setPaginaAtual_P(0);
        setPaginaAtual_C(0);
    };

    //--------------- EVENTOS POR STATUS ----------------------
    useEffect(() => {
        if (dataAtual) {
            // Eventos Pendentes, Abertos e Concluidos
            const baseGrupos = gruposSel.length === 0
                ? listaPesquisa.listaEvento
                : listaPesquisa.listaEvento.filter(ev => gruposSel.includes(grupoDoEvento(ev.tipoEvento)));
            const aber = baseGrupos.filter(ev => ev.status !== 'C' && (addDays(new Date(ev.dataEvento), 7) > dataAtual));
            const pend = baseGrupos.filter(ev => ev.status !== 'C' && (addDays(new Date(ev.dataEvento), 7) < dataAtual));
            const Concluido = baseGrupos.filter(ev => (ev.valorPag && ev.dataPag && ev.status === 'C') || ev.status === 'C');

            setabertoEvento(aber);
            setpendenteEvento(pend);
            setConcluidovento(Concluido);
        
            // --------------------
            // filtrar fornecedores dos eventos pesquisados
            const fornecedores = listaPesquisa.listaEvento.map(ev => ({nome: ev.id_Fornecedor?.nome, id: ev.id_Fornecedor?._id}));
            // Convertendo para Set para remover duplicatas, depois volta para array
            const arraySemDuplicatasForn = [...new Set(fornecedores.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));
            // remover do array objeto vazio
            const arraySemFornVazios = arraySemDuplicatasForn.filter(objeto => Object.keys(objeto).length > 0);

            // --------------------
            // filtrar TipoEvento dos eventos pesquisados
            const tipoEvento = listaPesquisa.listaEvento.map(ev => ev.tipoEvento);
            // Convertendo para Set para remover duplicatas, depois de volta para array
            const arraySemDuplicatasTipo = [...new Set(tipoEvento)];
            // remover elementos vazios de um array
            const arraySemTipoVazio = arraySemDuplicatasTipo.filter(elemento => elemento); 

            // --------------------
            // filtrar userCadastro dos eventos pesquisados
            const userCadastro = listaPesquisa.listaEvento.map(ev => ({nome: ev.userCadastro?.nome, id: ev.userCadastro?._id}));
            // Convertendo para Set para remover duplicatas, depois volta para array
            const arraySemDuplicatasUser = [...new Set(userCadastro.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));
            // remover do array objeto vazio
            const arraySemUserVazios = arraySemDuplicatasUser.filter(objeto => Object.keys(objeto).length > 0);

            // --------------------
            setAberto_For([]);
            setPendente_For([]);
            setConcluido_For([]);

            for (let i = 0; i < arraySemFornVazios.length; i++) {
                const eventosForn_Aberto = aber.filter(ev => ev.id_Fornecedor?._id === arraySemFornVazios[i].id);
                const eventosForn_Pendente = pend.filter(ev => ev.id_Fornecedor?._id === arraySemFornVazios[i].id);
                const eventosForn_Concluido = Concluido.filter(ev => ev.id_Fornecedor?._id === arraySemFornVazios[i].id);

                // Fazer um push no estado // criar um objeto com nome do fornecedor e os eventos.
                if(eventosForn_Aberto.length > 0){
                    const obj = { 
                        nome: arraySemFornVazios[i].nome, 
                        eventos: eventosForn_Aberto,
                        orcamento: ValorSomaTotal(eventosForn_Aberto), 
                    };
                    arraySemFornVazios.length > 1 ? setAberto_For(prev => [...prev, obj]) : setAberto_For([obj]);                    
                };

                // Fazer um push no estado // criar um objeto com nome do fornecedor e os eventos.
                if(eventosForn_Pendente.length > 0){
                    const obj = { 
                        nome: arraySemFornVazios[i].nome, 
                        eventos: eventosForn_Pendente,
                        orcamento: ValorSomaTotal(eventosForn_Pendente), 
                    };
                    arraySemFornVazios.length > 1 ? setPendente_For(prev => [...prev, obj]) : setPendente_For([obj]);  
                };

                // Fazer um push no estado // criar um objeto com nome do fornecedor e os eventos.
                if(eventosForn_Concluido.length > 0){
                    const obj = { 
                        nome: arraySemFornVazios[i].nome, 
                        eventos: eventosForn_Concluido,
                        orcamento: ValorSomaTotal(eventosForn_Concluido), 
                    };
                    arraySemFornVazios.length > 1 ? setConcluido_For(prev => [...prev, obj]) : setConcluido_For([obj]); 
                };
                
            };

            const eventosSemFornecedor_Aberto = aber.filter(ev => !ev.id_Fornecedor?._id);
            const eventosSemFornecedor_Pendente = pend.filter(ev => !ev.id_Fornecedor?._id);
            const eventosSemFornecedor_Concluido = Concluido.filter(ev => !ev.id_Fornecedor?._id);

            if (eventosSemFornecedor_Aberto.length > 0) {
                setAberto_For(prev => [...prev, {
                    nome: 'Sem fornecedor',
                    eventos: eventosSemFornecedor_Aberto,
                    orcamento: ValorSomaTotal(eventosSemFornecedor_Aberto),
                }]);
            }

            if (eventosSemFornecedor_Pendente.length > 0) {
                setPendente_For(prev => [...prev, {
                    nome: 'Sem fornecedor',
                    eventos: eventosSemFornecedor_Pendente,
                    orcamento: ValorSomaTotal(eventosSemFornecedor_Pendente),
                }]);
            }

            if (eventosSemFornecedor_Concluido.length > 0) {
                setConcluido_For(prev => [...prev, {
                    nome: 'Sem fornecedor',
                    eventos: eventosSemFornecedor_Concluido,
                    orcamento: ValorSomaTotal(eventosSemFornecedor_Concluido),
                }]);
            }

            // --------------------
            dispatch({
                type: 'set_ListaPesquisa',
                payload: { 
                    ...listaPesquisa, 
                    listaFornecedor: arraySemFornVazios.length >= 1 ? arraySemFornVazios : listaPesquisa.listaFornecedor,
                    listaTipoEvento: arraySemTipoVazio.length >= 1 ? arraySemTipoVazio : listaPesquisa.listaTipoEvento,
                    listaUsuario: arraySemUserVazios.length >= 1 ? arraySemUserVazios : listaPesquisa.listaUsuario,
                }
            });
        };
    }, [listaPesquisa.listaEvento, gruposSel]);

    // ---------------------------------
    const [eventoNaoEncontradoBusca, seteventoNaoEncontrado] = useState(false)
    // Filtro de grupo ativo sem nenhum evento em aberto, pendente ou concluído
    const eventoNaoEncontrado = eventoNaoEncontradoBusca || (
        gruposSel.length > 0
        && abertoEvento.length === 0
        && pendenteEvento.length === 0
        && Concluidovento.length === 0
    );
    // ----------------------------------

    useEffect(() => {
    //   Filtrar Lista Evento por userCadastro
        if (listaPesquisa.id_nomeUser) {
            const eventosUser = listaPesquisa.listaEvento.filter(ev => ev.userCadastro?._id === listaPesquisa.id_nomeUser);
            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: eventosUser }
            });
        }
    }, [listaPesquisa.id_nomeUser])

    // ----------------------------------

    useEffect(() => {
    //   Filtrar Lista Evento por id_Fornecedor.nome
        if (listaPesquisa.SelectForn) {
            const eventosForn = listaPesquisa.listaEvento.filter(ev => ev.id_Fornecedor?.nome === listaPesquisa.SelectForn);
            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: eventosForn }
            });
        }
    }, [listaPesquisa.SelectForn])

    // ----------------------------------

    useEffect(() => {
    //   Filtrar Lista Evento por tipoEvento
        if (evento.tipoEvento) {
            const eventosTipo = listaPesquisa.listaEvento.filter(ev => ev.tipoEvento === evento.tipoEvento);
            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: eventosTipo }
            });
        }
    }, [evento.tipoEvento])

    //----------Codição de formaçao de Grid----------
    const [listaGrid, setListaGrid] = useState([]);
    const [grid_A, setgrid_A] = useState(false);
    const [grid_P, setgrid_P] = useState(false);
    const [grid_C, setgrid_C] = useState(false); 
    
    const somaAberto = ValorSomaTotal(abertoEvento);
    const somaPendente = ValorSomaTotal(pendenteEvento);
    const somaConcluido = ValorSomaTotal(Concluidovento);

    // ---// Calcular Valores TOTAL de serviços------
    function ValorSomaTotal(Lista) {
        let somaTotal = 0;
        if (Lista.length > 0) {
            const somaOrcam = Lista.map((e) => e.orcamento);

            for (let i = 0; i < somaOrcam.length; i++) {
                if (somaOrcam[i] > 0) {
                    somaTotal += somaOrcam[i];
                };
            };
        };
        return somaTotal;
    };

    //-------------------------------
    useEffect(() => {
        const xx = [];
        if (abertoEvento.length > 0) { xx.push("1"); setgrid_A(true); } else { setgrid_A(false) };
        if (pendenteEvento.length > 0) { xx.push("1"); setgrid_P(true); } else { setgrid_P(false) };
        if (Concluidovento.length > 0) { xx.push("1"); setgrid_C(true); } else { setgrid_C(false) };
        setListaGrid(xx)
    }, [abertoEvento, pendenteEvento, Concluidovento]);

    // -------------------------------
    useEffect(() => {
            if (listaPesquisa.listaVeiculo.length > 0) {
                const t = listaPesquisa.listaVeiculo[0];
                dispatch({
                    type: 'set_cliente',
                    payload: {
                        ...cliente,
                        id_Cliente: t?.id_Cliente?._id,
                        nome: t?.id_Cliente?.nome,
                        cpfCnpj: t?.id_Cliente?.cpfCnpj,
                        celular: t?.id_Cliente?.foneCelular?.numeroCel,
                    }
                });
    
                dispatch({
                    type: 'set_veiculo',
                    payload: {
                        ...veiculo,
                        id_Veiculo: t?._id,
                        id_ClienteVeiculo: t?.id_Cliente?._id || "",
                        tipo: t?.tipo,
                        placa: t?.placa,
                        modelo: t?.modelo,
                        anoMod: t?.anoMod,
                        cor: t?.cor,
                        marca: t?.marca,
                        valorFipe: t?.valorFipe,
                        situacao: t?.situacao,
                    }
                });

                
            };
        }, [listaPesquisa.listaVeiculo]);
    // --------------------------------

    //###################################################################################################
    return (
        <>
            {/* -------------EVENTO------------------------ */}
            {displayModal.eventoDisplay &&
                <S.ContainerLista>
                    <S.containerPesq style={{marginBottom:"5px"}}>
                        <PesquisaPadrao
                        playTudo={true}
                        refPlaca={true}
                        playBotao={true}
                        Lupa={true}
                        titulo="Buscar Eventos"
                        placeholder="placa"
                        nomeBotao="Novo Evento"
                        Pesquisar={PesquisarEvento}
                        PesquisarData={PesqPorData}
                        PesquisaUserCad={PesquisaUserCad}
                        playModal_Add={Play_Modal_Add}
                        PesqDentroModal={false}
                        />
                    </S.containerPesq>

                    
                    {/* Filtro de Grupos de Evento */}
                    {!parametroInit.detalhesLista &&
                    <div style={{ display: 'flex', gap: '16px', margin: '5px 0 10px' }}>
                        {GRUPOS_EVENTO
                            .filter(g => (listaPesquisa.listaEvento || []).some(ev => grupoDoEvento(ev.tipoEvento) === g.key))
                            .map(g => (
                            <label key={g.key} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                <input
                                    type="checkbox"
                                    checked={gruposSel.includes(g.key)}
                                    onChange={() => toggleGrupo(g.key)}
                                />
                                {g.label}
                            </label>
                        ))}
                    </div>
                    }

                    {/* LISTA ------------------------ */}
                    <S.ModalConteine>
                        {loading && !playmodal.playModalEven && 
                        <>
                        <S.bodyresult>
                            <LoadingContent />
                        </S.bodyresult>
                        </>
                        }
                        {!loading && eventoNaoEncontrado && 
                        <>
                        <div style={{ display: "flex", maxWidth: "500px", justifyContent: "center" }}>
                            <div className={'titulo'}>
                                <div className={'tituloUser'}>
                                    Evento Não Encontrado!
                                </div>
                            </div>
                        </div>
                        </>
                        }
                        
                        { 
                        !loading && <>
                            {listaPesquisa.listaEvento.length > 0 &&
                            <S.bodyColunas>
                                {props.alertDelete &&
                                <AlertComp
                                    alertDescrit={'Deseja mesmo Excluir?'}
                                    seSim={ExcluirEste}
                                    seNao={FecharAlerte}
                                />
                                }
                                <S.divGrid listaGrid={listaGrid.length} grid_A={grid_A} grid_P={grid_P} grid_C={grid_C}>
                                    {abertoEvento.length > 0 &&
                                    <div className='colunaA'>
                                        <Paginacao
                                            ListaItens={Aberto_For}
                                            pageN={paginaAtualA}
                                            setPaginaAtual={setPaginaAtual_A}
                                            itemsPage={itemsPage}
                                        />
                                        <ListaEventos
                                            titulo="Aberto"
                                            listaBusca={Aberto_For.slice(startIndexA, endIndexA)} //slice(startIndexA, endIndexA) para paginação
                                            listaLancamento={Aberto_For}
                                            alertDelete={props.alertDelete}
                                            setAletDelete={ props.setAletDelete}
                                            newStatus={newStatus}
                                            setNewStatus={setNewStatus}
                                            setRefDelet={setRefDelet}
                                            PesqEventoCod={PesqEventoCod}
                                            SomaTotal={somaAberto}
                                        />
                                    </div>
                                    }
                                    {pendenteEvento.length > 0 &&
                                        <div className='colunaP'>
                                            <Paginacao
                                                ListaItens={Pendente_For}
                                                pageN={paginaAtualP}
                                                setPaginaAtual={setPaginaAtual_P}
                                                itemsPage={itemsPage}
                                            />
                                            <ListaEventos
                                                titulo="Pendente"
                                                listaBusca={Pendente_For.slice(startIndexP, endIndexP)}
                                                listaLancamento={Pendente_For}
                                                alertDelete={ props.alertDelete}
                                                setAletDelete={ props.setAletDelete}
                                                newStatus={newStatus}
                                                setNewStatus={setNewStatus}
                                                setRefDelet={setRefDelet}
                                                PesqEventoCod={PesqEventoCod}
                                                SomaTotal={somaPendente}
                                            />
                                        </div>
                                    }
                                    {Concluidovento.length > 0 &&
                                        <div className='colunaC'>
                                            <Paginacao
                                                ListaItens={Concluido_For}
                                                pageN={paginaAtualC}
                                                setPaginaAtual={setPaginaAtual_C}
                                                itemsPage={itemsPage}
                                            />
                                            <ListaEventos
                                                titulo="Concluido"
                                                listaBusca={Concluido_For.slice(startIndexC, endIndexC)}
                                                listaLancamento={Concluido_For}
                                                alertDelete={props.alertDelete}
                                                setAletDelete={ props.setAletDelete}
                                                newStatus={newStatus}
                                                setNewStatus={setNewStatus}
                                                setRefDelet={setRefDelet}
                                                PesqEventoCod={PesqEventoCod}
                                                SomaTotal={somaConcluido}
                                            />
                                        </div>
                                    }
                                </S.divGrid>
                            </S.bodyColunas>
                            }

                            {parametroInit.detalhesLista &&
                            <div className='detalhes'>
                                {playmodal.playModalDetalhesEven && listaPesquisa.listaEvento.length > 0 &&
                                <>
                                <DetalheEvento
                                titulo="Concluido"
                                alertDelete={ props.alertDelete}
                                setAletDelete={ props.setAletDelete}
                                newStatus={newStatus}
                                setNewStatus={setNewStatus}
                                setRefDelet={setRefDelet}
                                PesqEventoCod={PesqEventoCod}
                                />
                                </>}

                                {playmodal.playModalOrcamento &&
                                <AddOrcamento
                                nomeLS={evento.placa}
                                />
                                }
                            </div>
                            }
                        </>}

                        {/* <AddOrcamento
                            nomeLS={"HHH5060"}
                        /> */}

                        {playmodal.playModalEven && !parametroInit.NaoLocalizado &&
                        <>
                        <S.ModalFlutuante>
                            <ModalEvento
                            FecharModal={FecharModal}
                            Lupa={true}
                            PesqIdEvento={PesqIdEvento}
                            BuscaTodosEventos={BuscaTodosEventos}
                            />
                        </S.ModalFlutuante>
                        </>}
                        
                        {
                        playmodal.playModalEvenPlaca && veiculo.id_Veiculo &&
                        <S.Modal>
                            <div style={{ display: "flex", maxWidth: "500px", zIndex: "3",}}>
                                <CondutorEvento
                                    titulo="DADOS DO ASSOCIADO"
                                    CondutorAssociado={false}
                                    setLoadCarregar={()=>{}}
                                    onOk={false}
                                    setOnOk={()=>{}}
                                    condutorOutro={false}
                                    tipoVistoria={""}
                                    setTipoVistoria={()=>{}}
                                    setOutroCondutor={()=>{}}
                                    setCondutorAssociado={()=>{}}
                                    setModalCondutor={()=>{}}
                                    setCarregarTela={()=>{}}
                                    FecharModal={FecharModal}
                                    PesqIdEvento={PesqIdEvento}
                                />  
                            </div>
                        </S.Modal>
                        }

                        {
                        playmodal.playModalVeiculo &&
                        <S.Modal style={{zIndex:"3", position: "relative"}}>
                            <ModalVeiculo/>
                        </S.Modal>
                        }

                    </S.ModalConteine>
                </S.ContainerLista>
            }
        </>
    )
}